import {matchPath} from 'react-router-dom';

export const getPathIdFromUrl = (url, layout) => {
  for (const pathId in layout.pagesByPath) {
    if (matchPath(pathId, url)) {
      return pathId;
    }
  }
};
